import { Layout, Menu, Typography } from 'antd';
import React from 'react';
import { DISCORD_LINK, TWITTER_LINK } from "../Constants";
import * as analytics from "../services/Analytics";
import "./Navigation.css";

export function Navigation({ selectedItem }) {

    return (
        <Layout.Header>
            <div className="navigation-logo">
                <Typography.Link className='navigation-logo-text' href='/'>🚀 Crypto Space Prison</Typography.Link>
            </div>
            <Menu theme="dark" mode="horizontal" defaultSelectedKeys={[selectedItem]} >
                <Menu.Item key="season_origin">
                    <Typography.Link href="/#season_origin">Season Origin</Typography.Link>
                </Menu.Item>
                <Menu.Item key="season_two">
                    <Typography.Link href="/#season_two">Season Two</Typography.Link>
                </Menu.Item>
                <Menu.Item key="roadmap">
                    <Typography.Link href="/#roadmap">Roadmap</Typography.Link>
                </Menu.Item>
                <Menu.Item key="faq">
                    <Typography.Link href="/#faq">FAQ</Typography.Link>
                </Menu.Item>
                <Menu.Item key="community">
                    <Typography.Link href="/#community">Community</Typography.Link>
                </Menu.Item>
                <Menu.Item key="blog">
                    <Typography.Link href="/blog">Blog</Typography.Link>
                </Menu.Item>
                <Menu.Item key="dashboard">
                    <Typography.Link href="/dashboard">Dashboard</Typography.Link>
                </Menu.Item>
                <Menu.Item key="twitter">
                    <Typography.Link href={TWITTER_LINK} target="_blank" onClick={() => analytics.clickOpenTwitter()}>Twitter</Typography.Link>
                </Menu.Item>
                <Menu.Item key="discord">
                    <Typography.Link href={DISCORD_LINK} target="_blank" onClick={() => analytics.clickOpenDiscord()}>Discord</Typography.Link>
                </Menu.Item>
            </Menu>
        </Layout.Header>
    )

}